//if (document.getElementsByClassName("bl_modal_trigger")[0]) {
var modal_trigger = document.querySelectorAll("[data-modal]");
var modalclose = document.querySelectorAll(".modal_close");
var m_overlay = document.createElement("div");
var m_close = document.createElement("div");
var close_button = document.createElement("button");
var overlay_duration = 400;
m_overlay.id = "modal_overlay";
import {
    disableBodyScroll,
    enableBodyScroll,
    clearAllBodyScrollLocks
} from 'body-scroll-lock';
let dbody = document.body;
if (modal_trigger.length > 0) {
    for (let i = 0; i < modal_trigger.length; i++) {
        var el = modal_trigger[i];
        _addModalEvent(el);
    }
}
if (modalclose.length > 0) {
    for (let j = 0; j < modalclose.length; j++) {
        var cl = modalclose[j];
        _modalclose(cl);
    }
}

_modalclose2();

function _addModalEvent(el) {
    el.addEventListener("click", function (event) {
        var urlhash = event.currentTarget.getAttribute("href");
        event.preventDefault();
        var hash_selector = urlhash.replace(/([ !"$%&'()*+,.\/:;<=>?@[\]^`{|}~])/g, "\\$1");
        var target = document.querySelector(hash_selector);
        if (!target.classList.contains("modal")) {
            target.classList.add("modal");
        }
        var scrolltarget = target.querySelector(".wrap");
        disableBodyScroll(scrolltarget);

        //        target.style.opacity = 0;
        //        target.style.display = 'block';
        target.style.opacity = 0;

        dbody.appendChild(m_overlay);
        target.style.transition = "opacity " + overlay_duration + "ms ease-in-out";
        window.setTimeout(function () {
            target.classList.add("is-open");
            target.style.opacity = 1;
        }, 300);
        window.setTimeout(function () {
            target.style.removeProperty("display");
            target.style.removeProperty("opacity");
            target.style.removeProperty("transition");
            target.classList.add("opend");
        }, 300);
    });
}

function _modalclose(cl) {
    cl.addEventListener("click", function (event) {
        var modal = event.currentTarget.closest(".modal");
        event.preventDefault();

        modal.classList.remove("opend", "modal_open");

        //        modal.style.opacity = 1;
        m_overlay.style.opacity = 1;

        modal.style.transition = "opacity " + overlay_duration + "ms ease-in-out";
        m_overlay.style.transition = "opacity " + overlay_duration + "ms ease-in-out";

        window.setTimeout(function () {
            //            modal.style.opacity = 0;
            m_overlay.style.opacity = 0;
            modal.classList.remove("is-open");
        }, 10);
        window.setTimeout(function () {
            modal.classList.remove("is-close");
            modal.style.removeProperty("opacity");
            modal.style.removeProperty("transition");
            m_overlay.style.removeProperty("opacity");
            m_overlay.style.removeProperty("transition");
            dbody.removeChild(m_overlay);
        }, overlay_duration);
        if (modal.classList.contains("list_wrap")) {
            modal.classList.remove("modal");
        }
        //enableBodyScroll(modal);
        clearAllBodyScrollLocks();
    });
}

function _modalclose2() {
    m_overlay.addEventListener("click", function (event) {
        var modal = document.getElementsByClassName("is-open")[0];

        //        console.log(modal);

        modal.classList.remove("opend", "modal_open");
        //        modal.style.opacity = 1;
        m_overlay.style.opacity = 1;
        modal.style.transition = "opacity " + overlay_duration + "ms ease-in-out";
        m_overlay.style.transition = "opacity " + overlay_duration + "ms ease-in-out";

        window.setTimeout(function () {
            //            modal.style.opacity = 0;
            m_overlay.style.opacity = 0;
            modal.classList.remove("is-open");
        }, 10);
        window.setTimeout(function () {
            modal.classList.remove("is-close");
            modal.style.removeProperty("opacity");
            modal.style.removeProperty("transition");
            m_overlay.style.removeProperty("opacity");
            m_overlay.style.removeProperty("transition");
            dbody.removeChild(m_overlay);
        }, overlay_duration);
        if (modal.classList.contains("list_wrap")) {
            modal.classList.remove("modal");
        }
        //enableBodyScroll(modal);
        clearAllBodyScrollLocks();
    });
}

if (!Element.prototype.matches) {
    Element.prototype.matches =
        Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (el.matches(s)) return el;
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}
//}
